<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import usersView from "@/components/users/usersView.vue";

/**
 * Starter component
 */
export default {
    page: {
        title: "Users",
        meta: [{ name: "description", content: appConfig.description }],
    },
    components: { Layout, PageHeader, usersView },
    data() {
        return {
            title: "Users",
            items: [
                {
                    text: "User Management",
                    active: true,
                },
            ],
        };
    },
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <usersView />
    </Layout>
</template>
